import React, { useState, useRef, useEffect } from 'react';
import CheckboxInput from 'src/Member/components/common/checkbox';
import RadioInput from 'src/Member/components/common/radio';
import useDate from 'src/Member/utils/useDate';
import './dual-coverage.scss';

const DualCoverage = ({
  item,
  onSelectHandler = () => {},
  onDualCoverageRadioChange = () => {},
  selectedDualCoverageOption,
  multiSelect,
}) => {
  const { formatDate } = useDate();
  console.log('DualCoverage item', item);
  return (
    <div className="dual-coverage-container">
      <div className="select-member">
        <div>
          {multiSelect ? (
            <CheckboxInput
              inline
              key={item?.oid}
              label=""
              name={item?.oid}
              value={''}
              className="cursor-pointer"
              onChange={(e) => {
                onSelectHandler(e, item);
              }}
              checked={item?.isSelected}
            />
          ) : (
            <RadioInput
              key={item?.oid}
              label=""
              name="dualcoverage"
              className="cursor-pointer d-flex"
              value={item?.id}
              checked={item?.isSelected}
              onChange={(e) => {
                onDualCoverageRadioChange(e, item);
                if (
                  typeof document.getElementById('pgHeadingTitle') !==
                    'undefined' &&
                  document.getElementById('pgHeadingTitle') !== null
                ) {
                  document
                    .getElementById('pgHeadingTitle')
                    .removeAttribute('tabIndex');
                }
              }}
            />
          )}
        </div>
        <div className="dc-member-name">
          {item?.firstName} {item?.lastName} ({item?.userType})
        </div>
      </div>
      <div className="member-info">
        <div className="w50">
          <div className="dc-label">Employer</div>
          <div className="dc-value">{item?.employer}</div>
        </div>
        {/*<div className="w33">
          <div className="dc-label">Status</div>
          <div className="dc-value">{item?.status}</div>
        </div>*/}
        <div className="w50">
          <div className="dc-label">Coverage Period</div>
          <div className="dc-value">
            {formatDate(item?.DualCoverageEffectiveDate)} to{' '}
            {item?.DualCoveragTerminationDate !== 'null' &&
            item?.DualCoveragTerminationDate !== 'NULL' &&
            item?.DualCoveragTerminationDate !== undefined
              ? formatDate(item?.DualCoveragTerminationDate)
              : 'Current'}
            {/*item?.status === 'Terminated'
              ? formatDate(item?.DualCoveragTerminationDate)
              : 'Current'*/}
          </div>
        </div>
        {/*<div className="w34">
          <div className="dc-label">Effective Date</div>
          <div className="dc-value">{formatDate(item?.effectiveDate)}</div>
        </div>*/}
      </div>
    </div>
  );
};

export default DualCoverage;
